import { blue, grey } from '../../../common/styles/colours';
export var SearchBarStylePropertiesByVariant = {
    default: function (theme) { return ({
        borderColor: theme.borderPrimary || grey['300'],
        backgroundColor: theme.backgroundUI || grey['0'],
        placeholderTextColor: theme.contentTertiary || grey['600'],
        textColor: theme.contentPrimary || grey['900'],
        borderColorOnFocus: theme.contentAccent || blue['600'],
    }); },
    /* @deprecated - this is for temporary use for the search bar on a dark background */
    grey: function (theme) { return ({
        borderColor: theme.borderTertiary || grey['800'],
        backgroundColor: grey['700'],
        placeholderTextColor: grey['200'],
        textColor: theme.contentOnColor || grey['0'],
        borderColorOnFocus: theme.borderPrimary || grey['300'],
    }); },
};
//# sourceMappingURL=SearchBarStylePropertiesByVariant.js.map